export default "__VITE_ASSET__DsMsGQMF__"